import g, { useState as E, useRef as P, useEffect as u, useMemo as R, useCallback as _ } from "react";
import { I18N as h } from "../../../../js/i18n/index.js";
import { useKioskConfiguration as b } from "../../../features/api/repositories/kiosk/useKioskConfiguration.js";
import { i18nInstance as y } from "../../../features/i18n/i18n.js";
const x = g.createContext(
  null
), m = "home";
function U({
  kioskId: c,
  testMode: l,
  virtualKeyboard: f,
  children: k,
  onLoad: d
}) {
  const {
    isLoading: v,
    data: e
  } = b(c), [o, L] = E(m), i = P([m]), [p, C] = E(h.fallbackLng);
  function w(t) {
    C(t), y.changeLanguage(t);
  }
  u(() => {
    var r;
    const t = h.getPriorityLanguage(
      ((r = navigator == null ? void 0 : navigator.languages) == null ? void 0 : r.map((K) => K.split("-")[0])) ?? [],
      (e == null ? void 0 : e.common.settings.supportedLanguages) ?? []
    );
    w(t);
  }, [e]), u(() => {
    e && d && d(e);
  });
  function s(t, r = !1) {
    r && (i.current = []), i.current.push(t), L(t);
  }
  function T() {
    i.current.pop();
    const t = i.current[i.current.length - 1];
    t && L(t);
  }
  const I = R(() => ({
    kioskId: c,
    testMode: l,
    virtualKeyboard: f,
    currentPage: o,
    goTo: s,
    isLoading: v,
    configuration: e,
    back: T,
    lang: p,
    setLang: w,
    restart: () => s(m, !0)
  }), [
    o,
    c,
    l,
    f,
    e,
    v,
    p
  ]), a = P(null), n = _(() => {
    const t = (e == null ? void 0 : e.inactive.settings.inactiveTime) ?? 50;
    a.current && clearTimeout(a.current), a.current = setTimeout(() => {
      [
        "inactive-confirmation",
        "home"
      ].includes(o) || s("inactive-confirmation");
    }, t * 1e3);
  }, [e, o]);
  return u(() => (window.addEventListener("click", n), window.addEventListener("touchmove", n), window.addEventListener("scroll", n), () => {
    window.removeEventListener("click", n), window.removeEventListener("touchmove", n), window.removeEventListener("scroll", n);
  }), [e, o]), /* @__PURE__ */ g.createElement(x.Provider, { value: I }, k);
}
function j() {
  return g.useContext(x);
}
export {
  U as KioskLandingProvider,
  j as useKioskLanding
};
//# sourceMappingURL=context.js.map
